"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../shared/UiStateController");
var CfgLanguageEditor_1 = require("./ui/component/CfgLanguageEditor");
var CfgLanguageList_1 = require("./ui/component/CfgLanguageList");
var routes_1 = require("../../../shared/includes/routes");
var PCfgLanguageList = /** @class */ (function (_super) {
    __extends(PCfgLanguageList, _super);
    function PCfgLanguageList(props) {
        return _super.call(this, props) || this;
    }
    PCfgLanguageList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                page_size: data.tablePageSize
            });
        });
        this.setState({
            edit_mode: "LIST",
            record: null,
            //lang : CfgCountryListLangFactory.getLangInstance(this.props.state.getLang()),
            page_num: 1,
            page_size: this.props.state.getTablePageSize()
        });
    };
    PCfgLanguageList.prototype.componentWillUnmount = function () {
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    PCfgLanguageList.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW", record: null });
    };
    PCfgLanguageList.prototype.onEditClick = function (id) {
        this.setState({ edit_mode: "EDIT", record: id });
    };
    PCfgLanguageList.prototype.onGoBackClick = function () {
        this.setState({ edit_mode: "LIST", record: null });
    };
    PCfgLanguageList.prototype.onPageConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PCfgLanguageList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(CfgLanguageEditor_1.default, { data: this.props.data, state: this.props.state, record: null, onGoBack: this.onGoBackClick.bind(this) }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(CfgLanguageEditor_1.default, { data: this.props.data, state: this.props.state, record: this.state.record, onGoBack: this.onGoBackClick.bind(this) }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(CfgLanguageList_1.default, { data: this.props.data, state: this.props.state, onNewClick: this.onNewClick.bind(this), onEditClick: this.onEditClick.bind(this), onPageConfigChanged: this.onPageConfigChange.bind(this), pageNum: this.state.page_num, pageSize: this.state.page_size }));
        }
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PCfgLanguageList.prototype.render = function () {
        return this.getRenderObject();
    };
    PCfgLanguageList.getPageDescription = function (state) {
        return {
            icon: "language",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_config_language_config + "-id",
            itemTitle: "Языки",
            route: routes_1.routes.page_config_language_config,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PCfgLanguageList;
}(React.Component));
exports.default = PCfgLanguageList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cfg_language/PCfgLanguageList.tsx
// module id = 2163
// module chunks = 0